import { AccountObjectDto } from "../account-object/account-object.dto";
import { DtoInclude, DtoRef } from "../../../core/store/dto/dto";

export class ReportDto extends AccountObjectDto {
    @DtoRef
    reportLayout: string;
    @DtoRef
    job: string;

    title: string;
    message: string;
    attempted: string;
    completed: boolean;
    succeeded: boolean;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report/report.dto.ts